<div class="container-right-main fluid-container">
  <div class="static-content">
    <h2>How to access {{title}}</h2>
    <div class="" *ngFor="let role of helpData?.roles">
      <p><strong>For {{role.roleName}}:</strong></p>
      <ul *ngFor="let environment of role.environments">
        <li>{{environment.environment_name}}: {{environment.ad_group}}</li>
      </ul>
    </div>
    <p>Please go to <a href="{{helpData?.request_url}}" target="_blank">{{helpData?.request_url}}</a> to raise the group
      member request.</p>
    <!-- <h2>Prompt Guide</h2>
        <a href="../../../assets/Prompt steps for llm response.pdf" target="_blank">Click here to open prompt guide </a> -->
    <!-- <h2>How to submit feedback</h2>
      <ul>
        <li *ngFor="let process of helpData?.feedback_process">{{process?.step}}</li>
      </ul> -->
    <h2>To submit any issue</h2>
    <p>Please send out an email to <a href="mailto:{{helpData?.email}}">{{helpData?.email}}</a></p>
    <p><a class="submit-issue-link" *ngIf="isAdmin" (click)="openSubmitIssueDialog()">Submit an issue</a></p>
    <ng-container *ngIf="surveyLink">
      <h2>Survey</h2>
      <p><a [href]="surveyLink" target="_blank">Open Survey</a></p>
    </ng-container>
  </div>
</div>